 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"layout-default-Index":"layout-default-Index","layout-page-Index":"layout-page-Index","views-Authenticated":"views-Authenticated","views-Buttons":"views-Buttons","views-Calendar":"views-Calendar","views-Charts":"views-Charts","views-Dashboard":"views-Dashboard","views-DataTables":"views-DataTables","views-Error":"views-Error","views-ExtendedForms":"views-ExtendedForms","views-ExtendedTables":"views-ExtendedTables","views-FullscreenMap":"views-FullscreenMap","views-GoogleMaps":"views-GoogleMaps","views-Grid":"views-Grid","views-Icons":"views-Icons","views-League":"views-League","views-LeagueEdit":"views-LeagueEdit","views-LeagueMatch":"views-LeagueMatch","views-LeagueMatchEdit":"views-LeagueMatchEdit","views-LeagueMatches":"views-LeagueMatches","views-LeaguePlayers":"views-LeaguePlayers","views-Leagues":"views-Leagues","views-Lock":"views-Lock","views-Login":"views-Login","views-Notifications":"views-Notifications","views-Pricing":"views-Pricing","views-Profile":"views-Profile","views-Register":"views-Register","views-RegularForms":"views-RegularForms","views-RegularTables":"views-RegularTables","views-Rtl":"views-Rtl","views-StatsDashboard":"views-StatsDashboard","views-Tabs":"views-Tabs","views-Timeline":"views-Timeline","views-Typography":"views-Typography","views-UserProfile":"views-UserProfile","views-ValidationForms":"views-ValidationForms","views-Widgets":"views-Widgets","views-Wizard":"views-Wizard","default-app-bar":"default-app-bar","default-drawer":"default-drawer","default-footer":"default-footer","default-view":"default-view","default-account-settings":"default-account-settings","default-drawer-toggle":"default-drawer-toggle","default-drawer-header":"default-drawer-header","default-list":"default-list"}[chunkId]||chunkId) + "." + {"layout-default-Index":"a5687e10","layout-page-Index":"5d96dfdf","views-Authenticated":"18d858b1","views-Buttons":"d01744e3","views-Calendar":"953eb615","views-Charts":"f2a8e1aa","views-Dashboard":"23db24ee","views-DataTables":"b50d7b1a","views-Error":"6091bc42","views-ExtendedForms":"1005bd70","views-ExtendedTables":"de6dbcf5","views-FullscreenMap":"9865dde9","views-GoogleMaps":"5db72b31","views-Grid":"b77c4da5","views-Icons":"9f6e7ec9","views-League":"5649bfd6","views-LeagueEdit":"940d574d","views-LeagueMatch":"dcbefbe9","views-LeagueMatchEdit":"4036cfac","views-LeagueMatches":"508a7d38","views-LeaguePlayers":"5340279e","views-Leagues":"a70a836a","views-Lock":"84820b1a","views-Login":"8387c5d2","views-Notifications":"8d25b7ce","views-Pricing":"45896290","views-Profile":"11dbef20","views-Register":"70b280d3","views-RegularForms":"62a3eccc","views-RegularTables":"dc5188be","views-Rtl":"77e5f0fe","views-StatsDashboard":"13c12cda","views-Tabs":"61065588","views-Timeline":"081e0e9b","views-Typography":"0301b242","views-UserProfile":"e3af8ad0","views-ValidationForms":"056547bb","views-Widgets":"24daa9c3","views-Wizard":"d797f442","default-app-bar":"16c21254","default-drawer":"09e89f4a","default-footer":"eb40111d","default-view":"b172c8a7","chunk-4f2f6124":"aef0654d","default-account-settings":"474914f2","default-drawer-toggle":"374315a3","default-drawer-header":"383509e3","default-list":"0c782d8f","chunk-0002f178":"db070d65","chunk-ee72700c":"ecd66671","chunk-2d0c1f2c":"bc90b7fd","chunk-2d21e5a6":"bcec3261"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"layout-default-Index":1,"layout-page-Index":1,"views-Buttons":1,"views-Calendar":1,"views-Charts":1,"views-Dashboard":1,"views-Error":1,"views-ExtendedForms":1,"views-FullscreenMap":1,"views-League":1,"views-LeagueEdit":1,"views-LeagueMatchEdit":1,"views-LeagueMatches":1,"views-LeaguePlayers":1,"views-Login":1,"views-Pricing":1,"views-Profile":1,"views-Register":1,"views-RegularForms":1,"views-Rtl":1,"views-StatsDashboard":1,"views-Tabs":1,"views-Timeline":1,"views-ValidationForms":1,"views-Widgets":1,"views-Wizard":1,"default-app-bar":1,"default-drawer":1,"default-footer":1,"default-view":1,"chunk-4f2f6124":1,"chunk-0002f178":1,"chunk-ee72700c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"layout-default-Index":"layout-default-Index","layout-page-Index":"layout-page-Index","views-Authenticated":"views-Authenticated","views-Buttons":"views-Buttons","views-Calendar":"views-Calendar","views-Charts":"views-Charts","views-Dashboard":"views-Dashboard","views-DataTables":"views-DataTables","views-Error":"views-Error","views-ExtendedForms":"views-ExtendedForms","views-ExtendedTables":"views-ExtendedTables","views-FullscreenMap":"views-FullscreenMap","views-GoogleMaps":"views-GoogleMaps","views-Grid":"views-Grid","views-Icons":"views-Icons","views-League":"views-League","views-LeagueEdit":"views-LeagueEdit","views-LeagueMatch":"views-LeagueMatch","views-LeagueMatchEdit":"views-LeagueMatchEdit","views-LeagueMatches":"views-LeagueMatches","views-LeaguePlayers":"views-LeaguePlayers","views-Leagues":"views-Leagues","views-Lock":"views-Lock","views-Login":"views-Login","views-Notifications":"views-Notifications","views-Pricing":"views-Pricing","views-Profile":"views-Profile","views-Register":"views-Register","views-RegularForms":"views-RegularForms","views-RegularTables":"views-RegularTables","views-Rtl":"views-Rtl","views-StatsDashboard":"views-StatsDashboard","views-Tabs":"views-Tabs","views-Timeline":"views-Timeline","views-Typography":"views-Typography","views-UserProfile":"views-UserProfile","views-ValidationForms":"views-ValidationForms","views-Widgets":"views-Widgets","views-Wizard":"views-Wizard","default-app-bar":"default-app-bar","default-drawer":"default-drawer","default-footer":"default-footer","default-view":"default-view","default-account-settings":"default-account-settings","default-drawer-toggle":"default-drawer-toggle","default-drawer-header":"default-drawer-header","default-list":"default-list"}[chunkId]||chunkId) + "." + {"layout-default-Index":"d3635ab2","layout-page-Index":"d3635ab2","views-Authenticated":"31d6cfe0","views-Buttons":"a3912720","views-Calendar":"dfff998a","views-Charts":"71e9a1f3","views-Dashboard":"e9aba629","views-DataTables":"31d6cfe0","views-Error":"41c12922","views-ExtendedForms":"2f2af51c","views-ExtendedTables":"31d6cfe0","views-FullscreenMap":"ed16487a","views-GoogleMaps":"31d6cfe0","views-Grid":"31d6cfe0","views-Icons":"31d6cfe0","views-League":"3fbc67b3","views-LeagueEdit":"a3912720","views-LeagueMatch":"31d6cfe0","views-LeagueMatchEdit":"a3912720","views-LeagueMatches":"a3912720","views-LeaguePlayers":"a3912720","views-Leagues":"31d6cfe0","views-Lock":"31d6cfe0","views-Login":"6ae30e90","views-Notifications":"31d6cfe0","views-Pricing":"35e8b72f","views-Profile":"a3912720","views-Register":"8418d34a","views-RegularForms":"726b3234","views-RegularTables":"31d6cfe0","views-Rtl":"877ad165","views-StatsDashboard":"d2f347d0","views-Tabs":"68121000","views-Timeline":"877ad165","views-Typography":"31d6cfe0","views-UserProfile":"31d6cfe0","views-ValidationForms":"726b3234","views-Widgets":"877ad165","views-Wizard":"fff73c48","default-app-bar":"7afea8bb","default-drawer":"30c48abc","default-footer":"de049660","default-view":"f4f2c1ce","chunk-4f2f6124":"f4f2c1ce","default-account-settings":"31d6cfe0","default-drawer-toggle":"31d6cfe0","default-drawer-header":"31d6cfe0","default-list":"31d6cfe0","chunk-0002f178":"de049660","chunk-ee72700c":"7afea8bb","chunk-2d0c1f2c":"31d6cfe0","chunk-2d21e5a6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
